import { render } from "./fileup.vue?vue&type=template&id=3dd342ea"
import script from "./fileup.vue?vue&type=script&lang=js"
export * from "./fileup.vue?vue&type=script&lang=js"

import "./fileup.vue?vue&type=style&index=0&id=3dd342ea&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__